import React, { FC, RefObject } from "react";
import "./HorizontalScrollIndicator.scss";
import useHorizontalScrollIndicator from "../../hooks/useHorizontalScrollIndicator";

type Props = {
  loading: boolean;
  refTableContainer: RefObject<HTMLDivElement | null>;
  data?: unknown[];
};

const HorizontalScrollIndicator: FC<Props> = ({
  loading,
  refTableContainer,
  data = [],
}) => {
  const { hasScroll, scrollPercentage } = useHorizontalScrollIndicator(
    refTableContainer,
    data,
  );

  if (!hasScroll || loading) {
    return null;
  }

  return (
    <div className="scroll-indicator__container">
      <div className="scroll-indicator__border" />
      <div className="scroll-indicator">
        <span className="scroll-indicator__background" />
        {Array.from({ length: 5 }).map((_, index) => (
          <span
            className="scroll-indicator__horizontal-line"
            style={{ top: `${(index + 1) * 8}px` }}
            key={index}
          />
        ))}
        <span
          className="scroll-indicator__bar"
          style={{ left: `${scrollPercentage}%` }}
        ></span>
      </div>
    </div>
  );
};

export default HorizontalScrollIndicator;
